import {
  Component,
  DoCheck,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {PedidoLoja} from "../../objeto/PedidoLoja";
import {Pagamento} from "../../objeto/Pagamento";
import {AutorizacaoLojaService} from "../../services/autorizacao-loja.service";
import {DominiosService} from "../../services/dominios.service";
import {CadContatoLojaComponent} from "../cad-contato/cad-contato-loja.component";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {DialogService} from "@progress/kendo-angular-dialog";
import {PainelLoginComponent} from "../painel-login/painel-login.component";

@Component({
  selector: 'app-salvar-cartao-proximacompra',
  templateUrl: './salvar-cartao-proximacompra.component.html',
  styleUrls: ['./salvar-cartao-proximacompra.component.scss']
})
export class SalvarCartaoProximaCompraComponent implements OnInit, OnChanges  {
  @Input() mobile = true;
  @Input() pedido: PedidoLoja;
  @Input() pagamento: Pagamento;

  //no desktop mudar na tela pai
  @Input() telefone: string;
  @Input() idFormaPagamento: number;

  @Output() cartoesSalvosCarregados = new EventEmitter<any[]>();
  @Output() statusAlterado = new EventEmitter<any>();
  @Output() autenticacaoCancelada = new EventEmitter<void>();
  @Output() verificandoStatus = new EventEmitter<boolean>();
  @Output() autenticacaoSucesso = new EventEmitter<void>();

  salvarCartaoProximasCompras = false;
  statusStrongAuthCartao: any = null;
  processandoStrongAuthCartao = false;
  codigoStrongAuthCartao = '';
  canalStrongAuthCartao: string;
  mensagemCartaoSalvo: string;
  erroSalvarCartao: string;
  cartoesSalvosPagarme: any[] = [];
  exibirPopupAutenticacao = false;
  tempoReenviar = 0;
  intervaloReenviar: any;
  inputsCodigo: string[] = ['', '', '', '', '', ''];
  codigoEnviado = false;
  private ultimaChaveStatusCarregada = '';
  private atualizandoStatus = false;
  private atualizarStatusPendente = false;
  constructor( private autorizacao: AutorizacaoLojaService, private dominiosService: DominiosService,
               private activatedRoute: ActivatedRoute,  private location: Location,
               private router: Router,   private dialogService: DialogService) { }

  async ngOnInit() {
    await this.atualizeStatusStrongAuthCartao(true);
  }

  async ngOnChanges(changes: SimpleChanges) {
    console.log('ngOnChanges', changes )

    if (changes.pedido || changes.pagamento || changes.telefone ||  changes.idFormaPagamento) {
      await this.atualizeStatusStrongAuthCartao();
    } else {
      console.log('nao atualizar status')
    }
  }


  deveExibirConfigCartaoSalvo() {
    if(!this.formaPagamentoSalvaCartao() || !this.statusStrongAuthCartao) return false;

    if(!this.pagamentoCartaoPreenchido()) return false;

    return !this.statusStrongAuthCartao.sugerirLogin && !this.statusStrongAuthCartao.sugerirCadastro;
  }

  pagamentoCartaoPreenchido(){
    //nao esta preenchido cartao
    if(!this.pagamento.dadosCartao?.descricaoPagamento) return false;

    return true;

  }

  formaPagamentoSalvaCartao(){
    if(!this.pagamento || !this.pagamento.formaDePagamento)
      return false;

    const forma = this.pagamento.formaDePagamento;
    if(!forma.online || forma.pix || !forma.configMeioDePagamento)
      return false;

    return  forma.configMeioDePagamento.salvarCartao;
  }

 async alterouSalvarCartaoProximasCompras() {
    delete this.erroSalvarCartao;
    if(this.salvarCartaoProximasCompras)
      await this.atualizeStatusStrongAuthCartao( );

    this.salveUsarCartaoProximaCompra();
  }

  async atualizeStatusStrongAuthCartao(forcar = false){
    const telefone = this.pedido && this.pedido.contato ? this.pedido.contato.telefone : null;
    const codigoPais = this.pedido && this.pedido.contato ? (this.pedido.contato.codigoPais || '+55') : '+55';

    if(!telefone || telefone.trim().length < 11) {
      debugger
      this.statusStrongAuthCartao = null;
      this.ultimaChaveStatusCarregada = '';
      if(this.pagamento?.dadosCartao?.cartaoSalvoId)
        this.pagamento.dadosCartao = null;

      this.statusAlterado.emit(this.statusStrongAuthCartao);
      return;
    }

    const chaveAtual = `${codigoPais}|${telefone}`;
    if(!forcar && this.statusStrongAuthCartao && this.ultimaChaveStatusCarregada === chaveAtual)
      return;

    if(this.atualizandoStatus){
      this.atualizarStatusPendente = true;
      return;
    }

    this.atualizandoStatus = true;
    this.verificandoStatus.emit(true);
    this.processandoStrongAuthCartao = true;
    const status: any =  await  this.autorizacao.obtenhaStatusStrongAuth(telefone, codigoPais).catch((erro) => {
      console.error(erro)
      this.erroSalvarCartao = erro;
    })

    if(status){
      this.statusStrongAuthCartao = status || {};
      this.ultimaChaveStatusCarregada = chaveAtual;
      this.statusAlterado.emit(this.statusStrongAuthCartao);

      this.salvarCartaoProximasCompras = this.statusStrongAuthCartao.aceitouCartaoSalvo === true;
      const cartoesSalvos = this.statusStrongAuthCartao.cartoesSalvos || [];

      if(cartoesSalvos.length){
        this.cartoesSalvosPagarme = cartoesSalvos;
        this.cartoesSalvosCarregados.emit(this.cartoesSalvosPagarme);
      }
    }

    this.processandoStrongAuthCartao = false;
    this.verificandoStatus.emit(false);
    this.atualizandoStatus = false;

    if(this.atualizarStatusPendente){
      this.atualizarStatusPendente = false;
      await this.atualizeStatusStrongAuthCartao(true);
    }
  }

  soliciteCodigoStrongAuthCartao(abrirPopup = false){
    const telefone = this.pedido && this.pedido.contato ? this.pedido.contato.telefone : null;
    const codigoPais = this.pedido && this.pedido.contato ? (this.pedido.contato.codigoPais || '+55') : '+55';
    if(!telefone)
      return;

    if(abrirPopup)
      this.exibirPopupAutenticacao = true;

    this.canalStrongAuthCartao = 'email';
    this.processandoStrongAuthCartao = true;
    delete this.erroSalvarCartao;
    this.inputsCodigo = ['', '', '', '', '', ''];
    this.codigoStrongAuthCartao = '';
    this.autorizacao.envieCodigoStrongAuth(telefone, 'email', codigoPais).then((res: any) => {
      this.codigoEnviado = true;
      this.iniciarTimerReenvio();
    }).catch((erro) => {
      this.erroSalvarCartao = erro;
    }).finally(() => {
      this.processandoStrongAuthCartao = false;
    })
  }

  iniciarTimerReenvio() {
    this.tempoReenviar = 60 * 5;
    if (this.intervaloReenviar) clearInterval(this.intervaloReenviar);
    this.intervaloReenviar = setInterval(() => {
      this.tempoReenviar--;
      if (this.tempoReenviar <= 0) {
        clearInterval(this.intervaloReenviar);
      }
    }, 1000);
  }

  obtenhaEmailMascarado() {
    const email = this.pedido?.contato?.email || '';
    if (!email) return '';
    const [user, domain] = email.split('@');
    if (user.length <= 3) return email;
    return user.substring(0, 5) + '***@' + domain;
  }

  onDigitInput(event: any, index: number) {
    const input = event.target;
    const value = input.value;

    if (value.length === 1) {
      this.inputsCodigo[index] = value;
      if (index < 5) {
        const nextInput = document.getElementById('digit-' + (index + 1));
        if (nextInput) nextInput.focus();
      }
    } else if (value.length === 0 && event.key === 'Backspace') {
      this.inputsCodigo[index] = '';
      if (index > 0) {
        const prevInput = document.getElementById('digit-' + (index - 1));
        if (prevInput) prevInput.focus();
      }
    }

    this.codigoStrongAuthCartao = this.inputsCodigo.join('');
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedData = clipboardData.getData('Text').replace(/\D/g, '').substring(0, 6);

    if (pastedData) {
      for (let i = 0; i < pastedData.length; i++) {
        this.inputsCodigo[i] = pastedData[i];
      }
      this.codigoStrongAuthCartao = this.inputsCodigo.join('');
      const focusIndex = Math.min(pastedData.length, 5);
      setTimeout(() => {
        const nextInput = document.getElementById('digit-' + focusIndex);
        if (nextInput) nextInput.focus();
      }, 0);
    }
  }

  valideCodigoStrongAuthCartao(){
    const telefone = this.pedido && this.pedido.contato ? this.pedido.contato.telefone : null;
    const codigoPais = this.pedido && this.pedido.contato ? (this.pedido.contato.codigoPais || '+55') : '+55';
    if(!telefone || !this.codigoStrongAuthCartao)
      return;

    this.processandoStrongAuthCartao = true;
    delete this.mensagemCartaoSalvo;
    this.autorizacao.valideCodigoStrongAuth(telefone, this.codigoStrongAuthCartao, codigoPais).then(async () => {
      this.codigoStrongAuthCartao = '';
      this.canalStrongAuthCartao = null;
    // this.mensagemCartaoSalvo = 'Autenticação forte validada com sucesso.';
      this.exibirPopupAutenticacao = false;
      await this.atualizeStatusStrongAuthCartao();
      this.autenticacaoSucesso.emit();
    }).catch((erro) => {
      this.erroSalvarCartao = erro;
    }).finally(() => {
      this.processandoStrongAuthCartao = false;
    })
  }

  iniciarAutenticacao(){
    this.exibirPopupAutenticacao = true;
    this.codigoEnviado = false;
    this.erroSalvarCartao =  null;
  }

  async fecharPopup(){
    this.exibirPopupAutenticacao = false;
    if (this.intervaloReenviar) clearInterval(this.intervaloReenviar);
    await this.atualizeStatusStrongAuthCartao(true);
    this.autenticacaoCancelada.emit();
  }

  fazerLogin(){
    const telefone = this.pedido.contato?.telefone;
    if(this.mobile){
      this.dominiosService.vaParaLogin(window.location.pathname, telefone);
    } else {
      PainelLoginComponent.abraComoPopup(this.router, this.location, this.activatedRoute,
        this.dialogService, telefone , (result) => {
          if(result && result.login){
            let usuario = this.autorizacao.getUsuario();

            if(usuario && usuario.id)
              this.pedido.contato = usuario;
          }
        });
    }
    return false;
  }

  fazerCadastro(){
    this.pedido.contato.completarCadastro = true;
    if(this.mobile){
      this.dominiosService.vaParaCadastro(window.location.pathname, { contato: this.pedido.contato});
    } else {
      CadContatoLojaComponent.abraComoPopup(this.router, this.location, this.activatedRoute,
        this.dialogService, this.pedido.contato, async (result) => {
            if(result.id) await this.atualizeStatusStrongAuthCartao(true);

        }) ;
    }


    return false;
  }

  salveUsarCartaoProximaCompra(){
    if(this.salvarCartaoProximasCompras){
      if(!this.statusStrongAuthCartao.cadastroCompleto){
        this.salvarCartaoProximasCompras = false;
        this.erroSalvarCartao = 'Para salvar cartão, defina e-mail e senha no seu cadastro.';
        this.statusStrongAuthCartao = {
          ...(this.statusStrongAuthCartao || {}),
          sugerirCadastro: true
        };
        this.statusAlterado.emit(this.statusStrongAuthCartao);
        this.pedido.contato.atualizarCadastro = true;
        this.dominiosService.vaParaCadastro(window.location.pathname, {contato: this.pedido.contato});
        return;
      }

      if(!this.statusStrongAuthCartao.autenticacaoForteValida){
        this.salvarCartaoProximasCompras = false;
        this.erroSalvarCartao = 'Para salvar cartão, confirme sua identidade pelo código enviado no e-mail.';
        return;
      }
    }

    this.processandoStrongAuthCartao = true;
    this.autorizacao.salveOptinUsarCartao( this.salvarCartaoProximasCompras,
      this.pagamento.dadosCartao?.cartaoSalvoId ).then((resp: any) => {
      this.processandoStrongAuthCartao = false;
    }).catch((erro) => {
      this.salvarCartaoProximasCompras = !this.salvarCartaoProximasCompras;
      this.mensagemCartaoSalvo = erro;
      this.processandoStrongAuthCartao = false;
    })
  }

  private obtenhaChaveContato(): string {
    const telefone = this.pedido?.contato?.telefone || '';
    const codigoPais = this.pedido?.contato?.codigoPais || '+55';
    const formaPagamento = this.pagamento?.formaDePagamento?.id || this.pagamento?.formaDePagamento?.descricao || '';
    return `${codigoPais}|${telefone}|${formaPagamento}`;
  }
}
